module.exports = __webpack_public_path__ + "static/media/himalayas_nepal.03491054.jpg";